import React, { useState } from 'react';
import { Phone, MessageSquare, Calendar, MapPin, Globe, Instagram, Facebook, CheckCircle2, AlertCircle } from 'lucide-react';
import { Lead } from '../../types/lead';
import { BookingModal } from '../booking/BookingModal';
interface LeadContactBlockProps {
  lead: Lead;
}
export function LeadContactBlock({
  lead
}: LeadContactBlockProps) {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  return <div className="card p-5 space-y-6" data-id="element-278">
      <div data-id="element-279">
        <h3 className="text-sm font-semibold text-growthly-black mb-1" data-id="element-280">
          Contacto Principal
        </h3>
        <p className="text-base font-medium text-growthly-black" data-id="element-281">
          {lead.DECISOR_NOMBRE || 'No identificado'}
        </p>
        <p className="text-sm text-growthly-medium" data-id="element-282">
          {lead.DECISOR_CARGO || 'Cargo desconocido'}
        </p>
      </div>

      <div data-id="element-283">
        <div className="flex items-center justify-between mb-2" data-id="element-284">
          <span className="text-sm text-growthly-medium flex items-center" data-id="element-285">
            <Phone className="w-4 h-4 mr-2" data-id="element-286" />
            {lead.TELEFONO_WHATSAPP}
          </span>
          {lead.VERIFICADO ? <span className="flex items-center text-xs font-medium text-growthly-green bg-growthly-green/10 px-2 py-0.5 rounded" data-id="element-287">
              <CheckCircle2 className="w-3 h-3 mr-1" data-id="element-288" /> Verificado
            </span> : <span className="flex items-center text-xs font-medium text-growthly-red bg-growthly-red/10 px-2 py-0.5 rounded" data-id="element-289">
              <AlertCircle className="w-3 h-3 mr-1" data-id="element-290" /> No verificado
            </span>}
        </div>

        <div className="grid grid-cols-3 gap-2 mt-3" data-id="element-291">
          <button className="flex flex-col items-center justify-center p-2 border border-white/5 rounded-md hover:bg-white/5 transition-colors group" data-id="element-292">
            <Phone className="w-4 h-4 text-growthly-muted group-hover:text-growthly-text mb-1" data-id="element-293" />
            <span className="text-[10px] font-medium text-growthly-muted group-hover:text-growthly-text" data-id="element-294">
              Llamar
            </span>
          </button>
          <button className="flex flex-col items-center justify-center p-2 border border-white/5 rounded-md hover:bg-white/5 transition-colors group" data-id="element-295">
            <MessageSquare className="w-4 h-4 text-growthly-muted group-hover:text-growthly-text mb-1" data-id="element-296" />
            <span className="text-[10px] font-medium text-growthly-muted group-hover:text-growthly-text" data-id="element-297">
              WhatsApp
            </span>
          </button>
          <button onClick={() => setIsBookingOpen(true)} className="flex flex-col items-center justify-center p-2 border border-white/5 rounded-md hover:bg-white/5 transition-colors group" data-id="element-298">
            <Calendar className="w-4 h-4 text-growthly-muted group-hover:text-growthly-text mb-1" data-id="element-299" />
            <span className="text-[10px] font-medium text-growthly-muted group-hover:text-growthly-text" data-id="element-300">
              Agendar
            </span>
          </button>
        </div>
      </div>

      <div className="pt-4 border-t border-white/5 space-y-3" data-id="element-301">
        <div className="flex items-start" data-id="element-302">
          <MapPin className="w-4 h-4 text-growthly-medium mr-2 mt-0.5 flex-shrink-0" data-id="element-303" />
          <span className="text-sm text-growthly-medium" data-id="element-304">
            {lead.DIRECCION.calle} {lead.DIRECCION.numero},{' '}
            {lead.DIRECCION.barrio}, {lead.DIRECCION.ciudad}
          </span>
        </div>

        {lead.ENLACE_GMB && <div className="flex items-center" data-id="element-305">
            <Globe className="w-4 h-4 text-growthly-medium mr-2 flex-shrink-0" data-id="element-306" />
            <a href={lead.ENLACE_GMB} target="_blank" rel="noopener noreferrer" className="text-sm text-growthly-black hover:underline truncate" data-id="element-307">
              Ficha Google Maps
            </a>
          </div>}

        {(lead.RRSS_HANDLES.instagram || lead.RRSS_HANDLES.facebook) && <div className="flex items-center space-x-4" data-id="element-308">
            {lead.RRSS_HANDLES.instagram && <div className="flex items-center text-sm text-growthly-medium" data-id="element-309">
                <Instagram className="w-4 h-4 mr-1.5" data-id="element-310" />
                {lead.RRSS_HANDLES.instagram}
              </div>}
            {lead.RRSS_HANDLES.facebook && <div className="flex items-center text-sm text-growthly-medium" data-id="element-311">
                <Facebook className="w-4 h-4 mr-1.5" data-id="element-312" />
                {lead.RRSS_HANDLES.facebook}
              </div>}
          </div>}
      </div>

      <BookingModal isOpen={isBookingOpen} onClose={() => setIsBookingOpen(false)} leadName={lead.NOMBRE_NEGOCIO} data-id="element-313" />
    </div>;
}